<template>
  <div>

    <div class="d-flex justify-end mb-2">
      <memlist-icon-button
        class="mr-2"
        icon="menu-icon flaticon2-plus"
        :text="$t('TAB.INVOICE_TEMPLATES.NEW_TEMPLATE')"
        variant="primary"
        @click="new_clicked"
      />
    </div>


    <InvoiceTemplateEditorModal
      ref="invoice-template-editor-modal"
      :template="selected_template"
      @create="create_template"
      @update="update_template"
      @preview="preview_template_clicked"
      @cancel="cancel_clicked"
    />

    <memlist-static-table
      id="template-table"
      :fields="headers"
      :items="templates"
    >
      <template #cell(actions)="data">
        <div class='d-flex justify-content-end'>
          <span>
            <button class="btn btn-icon btn-light btn-sm mr-4 copy-action" @click.prevent="copy_clicked(data.item)">
              <span class="svg-icon svg-icon-md text-primary">
                <inline-svg src="/assets/svg/files.svg"></inline-svg>
              </span>
            </button>
            <button class="btn btn-icon btn-light btn-sm mr-4 edit-action" @click="edit_clicked(data.item)">
              <span class="svg-icon text-primary">
                <inline-svg src="/assets/svg/pencil-square.svg"></inline-svg>
              </span>
            </button>
            <button class="btn btn-icon btn-light btn-sm mr-4 delete-action" @click="delete_template_clicked(data.item)">
              <span class="svg-icon text-primary">
                <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
              </span>
            </button>

            <a
              class="btn btn-icon btn-light btn-sm mr-4"
              @click.prevent="preview_template_clicked(data.item)"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <inline-svg src="/assets/svg/vial-solid.svg"></inline-svg>
              </span>
            </a>
          </span>
        </div>
      </template>
    </memlist-static-table>
  </div>
</template>

<script>
import InvoiceTemplateEditorModal from '@/view/pages/ml/invoices/InvoiceTemplateEditorModal.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: "InvoiceTemplateTable",
  
  emits: [],
  mixins: [ toasts ],
  
  components: {
    InvoiceTemplateEditorModal
  },
  computed: {},
  mounted() {
    this.get_templates()
  },
  methods: {
    new_clicked() {
      this.selected_template = {};

      this.$nextTick(()=>{
        this.$refs['invoice-template-editor-modal'].show();
      });
    },

    copy_clicked(template) {

    },

    cancel_clicked() {},
    
    edit_clicked(item) {
      this.selected_template = item;
      
      this.$nextTick(()=>{
        this.$refs['invoice-template-editor-modal'].show();
      });
      
    },

    async update_template(template, close_editor) {
      try {
        const res = await axios.put(`/invoice_template/${template.id}`, template);
        if (res.status === 204) {
          const index = this.templates.findIndex(item => item.id === template.id);
          this.templates[index] = template;
          // Vue3 compatability for Vue.set
          this.templates = [...this.templates];

          if (close_editor) {
            template = null;
          }

          this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.INVOICE_TEMPLATES.UPDATED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_UPDATE'));
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_UPDATE'));
      }
    },


    async create_template(template, close_editor) {
      try {
        const res = await axios.post(`/invoice_template`, template);
        if (res.status === 201) {
          this.templates.push(template);
          if (close_editor) {
            template = null;
          }
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.INVOICE_TEMPLATES.CREATED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_CREATE'));
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_CREATE'));
      }
    },

    async delete_template_clicked(template) {
      try {
        const res = await axios.delete(`/invoice_template/${template.id}`);
        if (res.status === 204) {
          this.templates = this.templates.filter(item => item.id !== template.id);
          if (this.selected_template && this.selected_template.id === template.id) { this.selected_template = null; }
          this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.INVOICE_TEMPLATES.DELETED'));
        } else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_DELETE'));
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_DELETE'));
      }
    },

    async preview_template_clicked(template) {
      try {
        if (!template.id) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_PREVIEW'));
          return;
        }
        const response = await axios.post(`/invoice_template/preview/${template.id}`);

        if (response.status === 201) {
          downloadWithAxios(get_base_url() + `/dlfile/${response.data.linkstr}`, response.data.name);
        }
      }
      catch (err) {
        console.error('preview_template_clicked', err);
      }
    },


    async get_templates() {
      const loader = this.$loading.show();

      try {
        const res = await axios.get(`/invoice_template`);
        this.templates = res.data;
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.INVOICE_TEMPLATES.UNABLE_LIST'));
      } finally {
        loader && loader.hide();
      }
    },

  },
  data() {
    return {
      templates: [],
      selected_template: null,
      
      headers: [
        {
          key: 'name',
          show: true,
          sortable: true,
          label: this.$t('COMMON.NAME'),
          thClass: 'td-overflow',
          tdClass: 'td-overflow'
        },
        {
          key: 'created_at',
          show: true,
          sortable: true,
          label: this.$t('TAB.INVOICE_TEMPLATES.TH_CREATED_AT'),
          thClass: 'pl-7',
          tdClass: 'pl-7 vertical-center',
        },
        {
          key: 'actions',
          show: true,
          sortable: false,
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'td-short5',
        }
      ]
    };
  }
};
</script>
